import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_372: DocMigration = {
  maxSchemaVersion: "0.0.372",
  description: "Add effects to view template overrides",
  apply(json: any) {
    json.effects = {};

    for (const viewTemplateOverrideId in json.viewTemplateOverrides) {
      const viewTemplateOverride = json.viewTemplateOverrides[viewTemplateOverrideId];

      const sanitizedCategories = new Set<string>();

      // clean up some old categories that are no longer used
      for (const category of viewTemplateOverride.categories) {
        if (category === "ANNOT_LINEWORK_LINE" || category === "ANNOT_LINEWORK_FILL") {
          sanitizedCategories.add("ANNOT_LINEWORK");
        }
        if (validCategories.includes(category)) {
          sanitizedCategories.add(category);
        }
      }

      const effect = visibilityEffectNew(
        Array.from(sanitizedCategories),
        viewTemplateOverrideId,
        viewTemplateOverride.invertFilter,
      );

      json.effects[effect.id] = effect;

      delete viewTemplateOverride.invertFilter;
      delete viewTemplateOverride.categories;
    }

    return json;
  },
};

export default migration_0_0_372;

function visibilityEffectNew(categories: string[] = [], parentId: string, invert?: boolean) {
  return {
    id: uid(),
    type: "VISIBILITY",
    name: "Visibility Effect",
    categories,
    invert,
    parentId,
  };
}

const validCategories: string[] = [
  "ANNOT_DETAIL",
  "ANNOT_LINEWORK",
  "ANNOT_NOTE",
  "ANNOT_DIM_LABEL",
  "ANNOT_DIM_LINEWORK",
  "ANNOT_DIM_TICK",
  "ANNOT_DIM_WITNESS",
  "CEILING",
  "PROPS",
  "PROP_TAG",
];
